import { getLogger } from '@blueberry/observability'
import { poll } from '@blueberry/utils/common'
import { Flow } from '../types'

const logger = getLogger('signup/analytics/optibase')

declare global {
  interface Window {
    // optibase
    optibaseSendConversionEvent: (userFriendlyConversionId: string) => void
    optibaseInitialized: boolean
  }
}

export const optibase = {
  async trackStep(step: number) {
    const initialized = await poll(() => window.optibaseInitialized)
    if (!initialized) {
      logger.error(
        'Error: Retries exhausted waiting for Optibase to initialize',
      )
      return
    }

    try {
      switch (step) {
        case 1:
          window.optibaseSendConversionEvent('signup_page_1')
          break
        case 2:
          window.optibaseSendConversionEvent('signup_page_2')
          break
        case 3:
          window.optibaseSendConversionEvent('signup_page_3')
          break
      }
    } catch (error) {
      logger.error('Error tracking Optibase step event:', error)
      return
    }
  },
  async trackSuccess(flow: Flow) {
    // we currently only use optibase for d2c signup success tracking
    if (flow !== 'd2c') return

    const initialized = await poll(() => window.optibaseInitialized)
    if (!initialized) {
      logger.error(
        'Error: Retries exhausted waiting for Optibase to initialize',
      )
      return
    }

    try {
      window.optibaseSendConversionEvent('signup_success')
    } catch (error) {
      logger.error('Error tracking Optibase success event:', error)
      return
    }
  },
}
